module.exports = __webpack_public_path__ + "img/news-image-review6.303b5d67.png";